import React, { useState } from "react";
import { useContext } from "react";
import ModalContext from "../../../../contexts/ModalContext";
import { FreightContext } from "../../../../contexts/FreightContext";
import cross from '../../../../assets/orders/cross.svg'
import pen from '../../../../assets/router/edit-pen-white.svg'
import print from '../../../../assets/router/print.svg'
import duplicate from '../../../../assets/router/duplicate.svg'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    Text,
    TextLabel,
    GridContainer, 
    CloseDiv,
    CloseImg,
    OptionsDiv,
    ButtonOfSectionText,
    ButtonOfSection,
    IconImg,
    LineDiv
} from "./style";
import { format } from "date-fns";
import { ButtonCreate } from "../../style";
import ModalTest from "../../../BaseModal";
import { useNavigate } from "react-router-dom";
import axios from '../../../../config/axios'
import { FeedbackContext } from "../../../../contexts/FeedbackContext";

const FreightDetail = ()=>{
    const { setModalActive, setModalSection } = useContext(ModalContext);
    const {freight, setFreight} = useContext(FreightContext)
    const navigate = useNavigate()
    const [ isLoading, setIsLoading ] = useState(false)
    const [ error, setError ] = useState<string | null>(null)
    const { setFeedback } = useContext(FeedbackContext)
    const isCompleted = freight?.status === 'Coletado' || freight?.status === 'Entregue';
    const isAlreadyDuplicate = freight?.observation?.toUpperCase().includes('[CÓPIA]');
    const shouldHideDuplicateButton = isCompleted || isAlreadyDuplicate;

    const close = ()=>{
        
        // setModalActive(false);
        // setFreight(null)
        navigate('..')
    }

    const handleEdit = ()=>{
        // alert(freight?.address.street)
        // setModalActive(true);
        // setModalSection('routerForm')
        navigate('/panel/router/create')
    }

    const handleDuplicateFreight = async () => {
        const freightId = freight?.id; 
        
        if (!freightId) {
            setError("Não foi possível identificar o ID do frete para duplicação.");
            return;
        }

        setIsLoading(true);
        setError(null);
        
        try {
            const endpoint = `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/${freightId}/duplicate`;
            const response = await axios.post(endpoint);
            setFeedback({
                isOpen: true,
                message: 'Frete duplicado!',
                statusOk: true,
            })
            const newFreightId = response.data.id;
            console.log("Frete duplicado com sucesso. Redirecionando para edição do ID:", newFreightId);


            const duplicatedIdsRaw = sessionStorage.getItem('duplicatedFreights');
            const duplicatedIds = duplicatedIdsRaw ? JSON.parse(duplicatedIdsRaw) : [];
        
            if (!duplicatedIds.includes(newFreightId)) {
                duplicatedIds.push(newFreightId);
                sessionStorage.setItem('duplicatedFreights', JSON.stringify(duplicatedIds));
            }
            navigate('..');
            
        } catch (err) {
            console.error("Erro ao duplicar o frete:", err);
                setFeedback({
                    isOpen: true,
                    message: 'Erro ao duplicar frete',
                    statusOk: false,
                })

            } finally {
            setIsLoading(false);
        }
    };



    const dataFormatter = (isoDateString: string): string => {
      if (!isoDateString) {
          return ''; // Retorna vazio se a string for nula ou vazia
      }
  
      const dateUtc = new Date(isoDateString);
  
      // Verifica se a data é válida antes de tentar formatar
      if (isNaN(dateUtc.getTime())) {
          console.error("Data ISO inválida recebida:", isoDateString);
          return ''; // Trata o caso de uma string de data inválida
      }
  
      // Extrai as partes da data diretamente do UTC
      const year = dateUtc.getUTCFullYear();
      const month = dateUtc.getUTCMonth() + 1; // getUTCMonth é 0-indexado, então adiciona 1
      const day = dateUtc.getUTCDate();
  
      // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;
  
      return `${formattedDay}/${formattedMonth}/${year}`;
  };
    return(
        <>
        <ModalTest>
        <Container>
            <GridContainer>
            <HeaderDiv style={{gridArea: `titleNew`}}>
                <HeaderText>Frete {freight?.id?' - ' + freight?.id:''}</HeaderText>

                <CloseDiv onClick={() => close()} >
                    <CloseImg src={cross} alt='Close tab' />
                </CloseDiv>
            </HeaderDiv>

            <TextLabel style={{gridArea: `clientLabel`}}>Cliente/fornecedor </TextLabel>
            <Text style={{gridArea: `client`}}>{freight?.company?.companyName}</Text>

            <TextLabel style={{gridArea: `typeLabel`}}>Tipo </TextLabel>
            <Text style={{gridArea: `type`}}>{freight?.type}</Text>

            <TextLabel style={{gridArea: `dateLabel`}}>Data limite </TextLabel>
            <Text style={{gridArea: `date`}}>{freight?.deadLine && dataFormatter(freight.deadLine)}</Text>
            
            <TextLabel style={{gridArea: `orderLabel`}}>Número da venda </TextLabel>
            <Text style={{gridArea: `order`}}>{freight?.orderNumber}</Text>

            {
                freight?.address? (
                    <><LineDiv style={{gridArea: `line`}}></LineDiv>

                    <TextLabel style={{gridArea: `cepLabel`}}>CEP </TextLabel>
                    <Text>{freight?.address ? String(freight?.address?.cep).slice(0,5) + '-' + String(freight?.address?.cep).slice(5) : ''}</Text>
        
                    <TextLabel style={{gridArea: `streetLabel`}}>Logradouro </TextLabel>
                    <Text>{freight?.address?.street || ''}</Text>
        
                    <TextLabel style={{gridArea: `neighborhoodLabel`}}>Bairro </TextLabel>
                    <Text style={{gridArea: `neighborhood`}}>{freight?.address.neighborhood.name}</Text>
        
                    <TextLabel style={{gridArea: `numberLabel`}}>Número </TextLabel>
                    <Text style={{gridArea: `number`}}>{freight?.address?.number || ''}</Text>
        
                    <TextLabel style={{gridArea: `stateLabel`}}>Estado </TextLabel>
                    <Text style={{gridArea: `state`}}>{freight?.address?.neighborhood?.city?.state?.name || ''}</Text>
        
                    <TextLabel style={{gridArea: `cityLabel`}}>Cidade </TextLabel>
                    <Text style={{gridArea: `city`}}>{freight?.address.neighborhood.city.name}</Text>
        
                    <TextLabel style={{gridArea: `complementLabel`}}>Complemento </TextLabel>
                    <Text style={{gridArea: `complement`}}>{freight?.address?.complement || ''}</Text></>
                )
                :
                <></>
            }

            <LineDiv style={{gridArea: `line2`, marginTop: `1rem`}}></LineDiv>

            <TextLabel style={{gridArea: `heightLabel`}}>Altura </TextLabel>
            <Text style={{gridArea: `height`}}>{freight?.load?.height || 0}</Text>

            <TextLabel style={{gridArea: `widthLabel`}}>Largura </TextLabel>
            <Text style={{gridArea: `width`}}>{freight?.load?.width || 0}</Text>

            <TextLabel style={{gridArea: `lengthLabel`}}>Comprimento </TextLabel>
            <Text style={{gridArea: `length`}}>{freight?.load?.length || 0}</Text>

            <TextLabel style={{gridArea: `cubageLabel`}}>Cubagem</TextLabel>
            <Text style={{gridArea: `cubage`}}>{freight?.load?.cubage || 0}</Text>

            <TextLabel style={{gridArea: `weightLabel`}}>Peso </TextLabel>
            <Text style={{gridArea: `weight`}}>{freight?.load?.weight || 0}</Text>

            <TextLabel style={{gridArea: `detailsLabel`}}>Detalhamento </TextLabel>
            <Text style={{gridArea: `details`}}>{freight?.load?.detail || ''}</Text>

            <LineDiv style={{gridArea: `line3`, marginTop: `1rem`}}></LineDiv>
            <TextLabel style={{gridArea: `observationLabel`}}>Observações: </TextLabel>
            <Text style={{gridArea: `observation`,   overflowWrap: 'break-word'}}>{freight?.observation || ''}</Text>
            </GridContainer>
            
            <OptionsDiv>
                {!shouldHideDuplicateButton && (
                    <ButtonCreate 
                        className="reverse"
                        onClick={handleDuplicateFreight} 
                        disabled={isLoading || !freight?.id || shouldHideDuplicateButton} // Incluindo todas as suas regras
                    >
                        <IconImg src={duplicate} />
                        {isLoading ? 'Duplicando...' : 'Duplicar frete'}
                    </ButtonCreate>
                )}

            {/* Feedback de erro */}
            {error && <p style={{ color: 'red' }}>Erro: {error}</p>}
            <ButtonCreate className="reverse">
                <IconImg src={print}></IconImg>
                Imprimir
            </ButtonCreate>

            <ButtonCreate onClick={()=>{handleEdit()}} >
                <IconImg className="reverse" src={pen}></IconImg>
                Editar frete
            </ButtonCreate>
        </OptionsDiv>
        </Container>
        </ModalTest>
        
        </>
    )
}

export default FreightDetail;